<template>
  <div class="product-detail" :class="className" :id="productKey">
    <div class="product-detail-bg" :style="{ background: `radial-gradient(ellipse at 10% 50%, ${colorAccent}14 0%, transparent 60%)` }"></div>
    <div class="product-detail-header">
      <span class="detail-label">{{ $store.getters.t(`products.${productKey}.subtitle`) }}</span>
      <h2>{{ $store.getters.t(`products.${productKey}.name`) }}</h2>
    </div>
    <p class="product-detail-desc">{{ $store.getters.t(`products.${productKey}.detail`) }}</p>
    <div class="product-detail-grid" v-if="$store.getters.t(`products.${productKey}.detailItems`)">
      <div class="detail-card" v-for="(item, i) in $store.getters.t(`products.${productKey}.detailItems`)" :key="i">
        <div class="detail-card-icon" :style="{ background: `${colorAccent}1a`, color: colorAccent }">
          <span>{{ i + 1 }}</span>
        </div>
        <div class="detail-card-content">
          <h4>{{ item.title }}</h4>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  props: {
    productKey: { type: String, required: true },
    className: { type: String, default: 'product-detail-blue' },
    colorAccent: { type: String, default: '#3b82f6' }
  }
}
</script>

<style scoped>
.product-detail {
  margin-bottom: 100px;
  padding: 64px;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,.05);
  background: linear-gradient(180deg, rgba(20,30,50,.95), rgba(15,23,42,.98));
}
.product-detail-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.product-detail-header {
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.detail-label {
  display: inline-block;
  padding: 5px 16px;
  background: rgba(59,130,246,.12);
  border: 1px solid rgba(59,130,246,.2);
  border-radius: 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: #60a5fa;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 14px;
}
.product-detail-header h2 {
  font-size: 30px;
  font-weight: 700;
  color: #f1f5f9;
  position: relative;
  z-index: 1;
}
.product-detail-desc {
  color: #94a3b8;
  font-size: 15px;
  line-height: 1.85;
  max-width: 780px;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}
.product-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  position: relative;
  z-index: 1;
}
.detail-card {
  background: rgba(255,255,255,.025);
  border: 1px solid rgba(255,255,255,.05);
  border-radius: 14px;
  padding: 28px;
  display: flex;
  gap: 18px;
  transition: all .35s;
  align-items: flex-start;
}
.detail-card:hover {
  border-color: rgba(255,255,255,.1);
  background: rgba(255,255,255,.04);
  transform: translateY(-2px);
}
.detail-card-icon {
  width: 42px; height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 2px;
}
.detail-card-content { flex: 1; }
.detail-card-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #e2e8f0;
  margin-bottom: 6px;
}
.detail-card-content p {
  font-size: 13.5px;
  color: #64748b;
  line-height: 1.65;
}

@media (max-width: 768px) {
  .product-detail { padding: 36px 24px; margin-bottom: 60px; }
  .product-detail-grid { grid-template-columns: 1fr; }
  .product-detail-header h2 { font-size: 24px; }
  .detail-card { padding: 20px; }
}
</style>
